<template>
  <Header>
    <b-navbar toggleable="lg" id="design-header">
      <div style="height: 35px" class="pl-15 pr-10">
        <img
          style="height: 100%"
          :src="
            require(`@assets/images/logo/logo-${logoColor}/logo_mwe_minimal.png`)
          "
          v-b-tooltip.hover
          :title="builddetail"
        />
      </div>

      <!-- <VerticalLine class="mx-10"></VerticalLine>
      <PageSelect></PageSelect> -->
      <!-- <VerticalLine class="ml-10 mr-15"></VerticalLine> -->
      <!-- <b-dropdown
        toggle-class="text-decoration-none"
        no-caret
        variant="unset flag-dropdown p-10"
        v-b-tooltip.hover
        title="Switch Language"
      >
        <template #button-content>
          <i
            :class="`flag-icon flag-icon-${
              languages &&
              languages[languageUse] &&
              languages[languageUse].flagIcon
            }`"
          ></i>
          {{ languageUse && languageUse.toUpperCase() }}
          <i class="fal fa-chevron-down"></i>
        </template>
        <b-dropdown-item
          href="#"
          v-for="(item, lang, lang_index) in languages"
          :key="`Lang${lang_index}`"
          @click="switchLanguageUse(lang)"
        >
          <i :class="`flag-icon flag-icon-${item.flagIcon}`"></i>
          {{ item.nameRegion }}</b-dropdown-item
        >
      </b-dropdown> -->
      <!-- <VerticalLine class="mx-10"></VerticalLine> -->

      <div class="text-primary mr-gd-2 align-self-center" v-if="domain">
        <a class="fs-db-20 fw-400" :href="domain" target="_blank">{{ domainDisplay }}</a>
      </div>

      <div class="col">
        <div class="d-flex justify-content-center">
          <ScreenDevice
            :class="{ active: screenSize === 'Desktop' }"
            @click="setIframeDevice('Desktop')"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <i class="fal fa-desktop"></i>
          </ScreenDevice>
          <ScreenDevice
            :class="{ active: screenSize === 'Tablet' }"
            @click="setIframeDevice('Tablet')"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <i class="fal fa-tablet"></i>
          </ScreenDevice>
          <ScreenDevice
            :class="{ active: screenSize === 'Mobile' }"
            @click="setIframeDevice('Mobile')"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <i class="fal fa-mobile"></i>
          </ScreenDevice>
        </div>
      </div>
  
      <b-navbar-nav class="mr-gd-2">
        <b-button size="md" class="mx-1 fs-db-20 fw-400" variant="default" id="preview-btn" @click="goEditor">
          <i class="fas fa-times"></i>
          {{ $t("engine.topbar.btnClosepreview", languageEngine) }}
        </b-button>
        <b-button size="md" class="px-gd-2 ml-gd-1 fs-db-20 fw-400" variant="blue" @click="publishWebsite" :disabled="autoSaving">
          {{ $t("engine.topbar.btnPublish", languageEngine) }}
        </b-button>
        <b-overlay
          style="width: 100vw; height: 100vh"
          :show="publishing"
          no-wrap
        >
          <template #overlay>
            <div class="text-center">
              <b-icon
                class="mb-3"
                icon="stopwatch"
                font-scale="3"
                animation="cylon"
              ></b-icon>
              <b-progress
                :value="25"
                variant="success"
                striped
                :animated="true"
              ></b-progress>
              <p>Your website is Publishing Please wait...</p>
            </div>
          </template>
        </b-overlay>
      </b-navbar-nav>
    </b-navbar>
  </Header>
</template>

<script>
import { DateTime } from "luxon";
import styled from "vue-styled-components";
import { mapGetters } from "vuex";
// import PageSelect from "./PageSelect/PageSelect";
const Header = styled.div`
  .navbar {
    height: 56px;
    background-color: #fff;
    padding: 0;
    /* z-index: 10000; */
    z-index: 1036;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    border-bottom: 1px solid var(--line);
  }
  .select-page {
    min-width: 180px;
  }
  .page-title {
    color: #24BEE2;
  }
`;
// const VerticalLine = styled.div`
//   width: 1px;
//   height: 26px;
//   background-color: var(--line);
// `;
const ScreenDevice = styled.div`
  height: 56px;
  width: 40px;
  font-size: 20px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #CDD3DA;
  &::after {
    transition: all 0.1s ease;
    content: "";
    position: absolute;
    width: 100%;
    height: 0px;
    background-color: #24BEE2;
    bottom: 0;
  }

  &.active,
  &:hover {
    color: #24BEE2;
    &::after {
      height: 3px;
    }
  }
`;

export default {
  data() {
    return {
      langs: ["th", "en"],
      logoColor: process.env.VUE_APP_WEB_ICON_COLOR,
    };
  },
  components: {
    Header,
    // VerticalLine,
    ScreenDevice,
    // PageSelect,
  },
  mounted() {},
  methods: {
    setIframeDevice(size) {
      this.$store.dispatch("design/setScreenSize", { size: size });
      this.$store.dispatch("designIframe/setScreenSize", { size: size });
      this.$store.dispatch("designIframe/frame/setRenderTools", { renderTools: (size == 'Tablet') ? false : true });
    },
    publishWebsite() {
      this.$store.dispatch("design/page/publishWebsite");
    },
    switchLanguageUse(lang) {
      this.$store.dispatch("design/site/setLanguageUse", {
        language: lang,
      });
      this.$store.dispatch("designIframe/page/initLanguage", {
        language: lang,
      });
      this.$store.dispatch("designIframe/page/getSiteMetadata", {
        lang: lang,
      });
      this.$store.dispatch("designIframe/page/getPage", {
        metaDataID: "",
        lang: lang,
      });
    },
    goEditor() {
      this.$store.dispatch("design/setMode", {});
      let index = location.hash.indexOf('/anchor');
      let route = `/${index >= 0 ? location.hash.slice(0, index) : location.hash}`
      this.$router.push(route);
    },
  },
  computed: {
    ...mapGetters({
      domains: "design/page/domain",
      languages: "design/site/languages",
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      screenSize: "screenSize",
      publishStatus: "design/page/publishStatus",
      elActiveID: "designIframe/component/elActiveID",
      autoSaving: "design/snapshot/autoSaving",
    }),
    domain() {
      return this.domains.main && `https://${this.domains.main}`;
    },
    domainDisplay() {
      return this.domains.main;
    },
    publishing() {
      return this.publishStatus && this.publishStatus.status !== "published";
    },

    builddetail() {
      const dt = DateTime.fromISO(process.env.VUE_APP_BUILDDATE);
      return dt.toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
    },
  },
};
</script>

<style>
</style>